import React from 'react'
import { LinkAnchor } from '@babylon/medkit'
import { Link } from '@babylon/web-platform-ui'
import styles from '@/App.module.scss'
import replaceString from './replaceString'

type Replacer = {
  search: string | RegExp
  replace: (str: string) => string | JSX.Element
}

const SEPARATOR = '|'

// Strip leading and trailing curly braces and split the separator
const getValues = (str: string) =>
  str.substr(1, str.length - 2).split(SEPARATOR)

const phoneNumberRegex = /{tel\|[\d]+\|[\w-]+}/gi
const emailRegex = /{email\|[^@\s]+@[^@\s.]+\.[^@.\s]+}/gi

const phoneNumberReplacer: Replacer = {
  search: phoneNumberRegex,
  replace: (str: string) => {
    const [, href, displayValue] = getValues(str)

    return (
      <LinkAnchor href={`tel:${href}`} className={styles.whiteSpaceNoWrap}>
        {displayValue}
      </LinkAnchor>
    )
  },
}

const emailAddressReplacer: Replacer = {
  search: emailRegex, // A very basic email regex. Will match 99%.
  replace: (str: string) => {
    const [, email] = getValues(str)

    return (
      <LinkAnchor href={`mailto:${email}`} className={styles.whiteSpaceNoWrap}>
        {email}
      </LinkAnchor>
    )
  },
}

const phoneNumberReplacerV2: Replacer = {
  search: phoneNumberRegex,
  replace: (str: string) => {
    const [, href, displayValue] = getValues(str)

    return <Link href={`tel:${href}`}>{displayValue}</Link>
  },
}

const emailAddressReplacerV2: Replacer = {
  search: emailRegex, // A very basic email regex. Will match 99%.
  replace: (str: string) => {
    const [, email] = getValues(str)

    return <Link href={`mailto:${email}`}>{email}</Link>
  },
}

const replacers = [phoneNumberReplacer, emailAddressReplacer]
const V2Replacers = [phoneNumberReplacerV2, emailAddressReplacerV2]

const applyStringReplacers = (str: string, useDnaV2Design: Boolean) => {
  let source = [str]

  if (useDnaV2Design) {
    V2Replacers.forEach(({ search, replace }) => {
      source = replaceString(source, search, replace)
    })

    return source
  }

  replacers.forEach(({ search, replace }) => {
    source = replaceString(source, search, replace)
  })

  return source
}

export default applyStringReplacers
